<div class="solutions">
  <a class="pointer solution" *ngFor="let solutionName of item.cells[this.fieldDefinition?.key]?.value?.split(',')">{{solutionName}}</a>
</div>